<script setup lang="ts">
import { SQUARE_TRAVELER, CHILD_AND_CAMPER, SQUARE_KEYS } from '~/constants/pictures'

const { t } = useI18n()

useSeoText({ title: t('pages.rv_beginner.meta.title'), description: t('pages.rv_beginner.meta.description') })

const advices = [
  { title: t('pages.rv_beginner.advices.before.title'), content: t('pages.rv_beginner.advices.before.content') },
  { title: t('pages.rv_beginner.advices.parking.title'), content: t('pages.rv_beginner.advices.parking.content') },
  { title: t('pages.rv_beginner.advices.responsible.title'), content: t('pages.rv_beginner.advices.responsible.content') },
]

const articles = [
  {
    title: t('pages.rv_beginner.advantages.travel.title'),
    content: t('pages.rv_beginner.advantages.travel.content'),
    picture: CHILD_AND_CAMPER,
  },
  {
    title: t('pages.rv_beginner.advantages.owner.title'),
    content: t('pages.rv_beginner.advantages.owner.content'),
    picture: SQUARE_KEYS,
  },
  {
    title: t('pages.rv_beginner.advantages.freedom.title'),
    content: t('pages.rv_beginner.advantages.freedom.content'),
    picture: SQUARE_TRAVELER,
  },
]

const faqItems = [
  {
    question: t('pages.rv_beginner.faq.items.driving_licence.question'),
    answer: `<p>${t('pages.rv_beginner.faq.items.driving_licence.answer')}</p>`,
  },
  {
    question: t('pages.rv_beginner.faq.items.vehicle_type.question'),
    answer: `<p>${t('pages.rv_beginner.faq.items.vehicle_type.answer')}</p>`,
  },
  {
    question: t('pages.rv_beginner.faq.items.difficulty.question'),
    answer: `<p>${t('pages.rv_beginner.faq.items.difficulty.answer')}</p>`,
  },
  {
    question: t('pages.rv_beginner.faq.items.parking.question'),
    answer: `<p>${t('pages.rv_beginner.faq.items.parking.answer')}</p>`,
  },
  {
    question: t('pages.rv_beginner.faq.items.family.question'),
    answer: `<p>${t('pages.rv_beginner.faq.items.family.answer')}</p>`,
  },
]
const { getTranslatedLink } = useGetTranslatedLink()
</script>

<template>
  <div>
    <AppPageSection>
      <AppPageArticles :articles="articles" />

      <div class="text-center">
        <NuxtLink
          :to="{ name: 's' }"
          class="btn btn-primary"
        >
          {{ getTranslatedLink('s') }}
        </NuxtLink>
      </div>

      <AppPageSection
        class="bg-peacock-700"
        is-dark
        is-sub-section
      >
        <template #title>
          {{ $t('pages.rv_beginner.advices.title') }}
        </template>

        <div class="space-y-8 text-white md:flex md:flex-row md:space-x-8 md:space-y-0 md:px-2">
          <div
            v-for="item in advices"
            :key="item.title"
            class="md:w-1/3"
          >
            <h3 class="text-xl font-semibold">
              {{ item.title }}
            </h3>
            <p class="mt-3">
              {{ item.content }}
            </p>
          </div>
        </div>
      </AppPageSection>

      <div>
        <div class="mx-auto max-w-screen-lg space-y-8">
          <h3 class="text-center text-xl font-semibold lg:text-3xl">
            {{ $t('pages.rv_beginner.faq.title') }}
          </h3>
          <YscCollapseGroup :items="faqItems" />
        </div>
      </div>
    </AppPageSection>

    <AppPageSection class="bg-gray-50">
      <template #title>
        {{ $t('pages.rv_beginner.prevention.title') }}
      </template>

      <div class="md:flex md:justify-between md:space-x-6">
        <div class="mb-6 md:mx-4 md:mb-0 md:w-1/3 lg:w-1/2">
          <YscIframeVideo :url="$t('pages.rv_beginner.prevention.video')" />
        </div>
        <div class="md:mx-4 md:w-2/3 lg:w-1/2">
          <div class="prose mb-6">
            <p>
              {{ $t('pages.rv_beginner.prevention.content') }}
            </p>
            <ul>
              <li
                v-for="item in $t('pages.rv_beginner.prevention.list').split('\n')"
                :key="item"
              >
                {{ item }}
              </li>
            </ul>
          </div>
          <NuxtLink
            :to="{ name: 's' }"
            class="btn btn-primary"
          >
            {{ getTranslatedLink('s') }}
          </NuxtLink>
        </div>
      </div>
    </AppPageSection>
    <AppSearchSection />
  </div>
</template>
